import axios from "axios";
import { toast } from "react-hot-toast";

export const authHeaders = () => {
  const token =
    localStorage.getItem("auth-token") &&
    JSON.parse(localStorage.getItem("auth-token")).token;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const formAuthHeaders = () => {
  const token =
    localStorage.getItem("auth-token") &&
    JSON.parse(localStorage.getItem("auth-token")).token;
  return {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
};

// console.log("authHeaders",authHeaders());
// console.log("formAuthHeaders",formAuthHeaders());


const Axios = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  withCredentials: true,
});

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {

      // Show toast for session expiration
      toast.error("Session Expired. Please log in again.", {
        duration: 3000, // Toast disappears after 3 seconds
      });

      // Clear user data or handle redirection if needed
      localStorage.removeItem("auth-token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default Axios;
